import React, { useState } from 'react';
import { toast } from 'sonner';
import { FileSpreadsheet, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { API_BASE } from '../../lib/api';
import { getToken } from '../../lib/tokenStorage';

/* Export completo CRM (solo admin): un unico Excel con tutti i lead e tutti i loro dati. */
export const CrmFullExportButton = () => {
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const token = getToken();
      const resp = await fetch(`${API_BASE}/admin/crm-export/leads.xlsx`, {
        headers: token ? { Authorization: `Bearer ${token}` } : {},
      });
      if (!resp.ok) throw new Error(resp.status === 403 ? "Export riservato all'amministratore." : `Errore export (${resp.status})`);
      const blob = await resp.blob();
      const cd = resp.headers.get('Content-Disposition') || '';
      const m = cd.match(/filename="?([^";]+)"?/i);
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = m ? m[1] : 'crm_tutti_i_lead.xlsx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(link.href);
      toast.success('Excel con tutti i lead scaricato');
    } catch (err) {
      toast.error(err?.message || 'Errore export');
    } finally {
      setBusy(false);
    }
  };

  return (
    <Button
      size="sm"
      variant="outline"
      onClick={download}
      disabled={busy}
      data-testid="leads-export-full-xlsx-button"
      title="Scarica un unico file Excel con tutti i lead del CRM (IT, ES, EN, anche nel cestino) e tutti i loro dati"
    >
      {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <FileSpreadsheet className="w-4 h-4 mr-1" />}
      {busy ? 'Preparazione Excel…' : 'Esporta tutto il CRM (Excel)'}
    </Button>
  );
};
